import React from 'react';

type KpiVariant = 'neutral' | 'positive' | 'negative' | 'warning' | 'danger';

interface KpiCardProps {
  label: string;
  value: number;
  unit: string;
  sublabel?: string;
  variant?: KpiVariant;
}

const variantStyles: Record<KpiVariant, { text: string; bg: string; border: string }> = {
  neutral: {
    text: 'text-foreground',
    bg: 'bg-card',
    border: 'border-border',
  },
  positive: {
    text: 'text-price-negative',
    bg: 'bg-green-950/20',
    border: 'border-green-800/40',
  },
  negative: {
    text: 'text-price-negative',
    bg: 'bg-green-950/20',
    border: 'border-green-800/40',
  },
  warning: {
    text: 'text-price-high',
    bg: 'bg-amber-950/20',
    border: 'border-amber-800/40',
  },
  danger: {
    text: 'text-price-very-high',
    bg: 'bg-red-950/20',
    border: 'border-red-800/40',
  },
};

export default function KpiCard({
  label,
  value,
  unit,
  sublabel,
  variant = 'neutral',
}: KpiCardProps) {
  const styles = variantStyles[variant];

  return (
    <div
      className={`rounded-md border ${styles.border} ${styles.bg} p-4 sm:p-5 flex flex-col justify-between min-h-[110px]`}
    >
      <p className="label-caps mb-3">{label}</p>
      <div>
        <div className="flex items-baseline gap-1.5">
          <span
            className={`font-tabular font-bold text-2xl leading-none ${styles.text}`}
          >
            {value >= 0 ? value.toFixed(2) : value.toFixed(2)}
          </span>
          <span className="text-xs text-muted-foreground font-medium">{unit}</span>
        </div>
        {sublabel && (
          <p className="text-xs text-muted-foreground mt-1.5 font-tabular">
            {sublabel}
          </p>
        )}
      </div>
    </div>
  );
}